export const isNumberString = (value: unknown) =>
  typeof value === "string"
    ? !Number.isNaN(Number(value)) && value.trim() !== ""
    : typeof value === "number"
      ? !Number.isNaN(value)
      : false;
